import PropTypes from 'prop-types';
import React from 'react';

export const SimpleToggleButton = (props) => {
  const {
    selected,
    toggleSelected,
    firstOption,
    secondOption,
    width,
    rounded,
  } = props;
  const containerBorderRadius = rounded
    ? { width: width || '100%', borderRadius: '36px' }
    : { width: width || '100%' };
  const buttonBorderRadius = rounded ? { borderRadius: '20px' } : undefined;
  return (
    <div
      className={`${selected ? 'simple-toggle-container' : 'simple-toggle-container-disabled'}`}
      style={containerBorderRadius}
      onClick={toggleSelected}
    >
      <div
        className={`simple-toggle-button ${selected ? '' : 'simple-toggle-disabled'}`}
        style={buttonBorderRadius}
      >
        {selected ? firstOption : secondOption}
      </div>
      {/* {firstOption} {secondOption} */}
    </div>
  );
};

SimpleToggleButton.propTypes = {
  selected: PropTypes.bool.isRequired,
  toggleSelected: PropTypes.func.isRequired,
};
